import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TrademeCoreUiPipeModule } from '@classifieds-sell/shared';
import { TgGridModule, TgRackModule } from '@trademe/tangram';
import { SummaryPageSummarySectionComponent } from './summary-page-summary-section.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TgGridModule,
        TgRackModule,
        TrademeCoreUiPipeModule
    ],
    declarations: [SummaryPageSummarySectionComponent],
    exports: [SummaryPageSummarySectionComponent]
})
export class SummaryPageSummarySectionModule {}
